import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesArticulos() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "", items: [
      { label: "Marcas", icon: "far fa-copyright", color: "#0d9488", href: "/Marcas", enabled: !!(user.menu_articulos) },
      { label: "Departamentos", icon: "fas fa-list-ul", color: "#0d9488", href: "/ListadoDepartamentos", enabled: !!(user.menu_articulos) },
      { label: "Lineas", icon: "fas fa-list-ul", color: "#0d9488", href: "/ListadoSubDepartamentos", enabled: !!(user.menu_articulos) },
      { label: "Tallas", icon: "fas fa-ruler-horizontal", color: "#0d9488", href: "/ListadoTallas", enabled: !!(user.menu_articulos) },
      { label: "Variantes Tallas", icon: "fas fa-ruler-horizontal", color: "#0d9488", href: "/ListadoVariantesTallas", enabled: !!(user.menu_articulos) },
      { label: "Articulos", icon: "fas fa-tshirt", color: "#0d9488", href: "/ListadoArticulos", enabled: !!(user.menu_articulos) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Artículos"
      descripcion="Marcas, líneas, tallas y artículos"
      icono="fas fa-tshirt"
      color="#0d9488"
      secciones={secciones}
    />
  );
}

export default BotonesArticulos;
